/* RW Forms — combined form modules for all 7 RWF forms (contact, custom-product,
   disc, distributor, dropship, knife, recommend-product).
   Loaded once via rwf-assets.liquid on every RWF page; each form's start()
   below calls RWF.init on its own root selector, which returns null when
   that root isn't present on the current page, so only the matching form's
   IIFE ever does anything on a given page — no per-page JS needed.
   Each section is otherwise byte-identical to the original per-form file it
   replaces (see git history: rwf-contact.js, rwf-custom-product.js,
   rwf-disc.js, rwf-distributor.js, rwf-dropship.js, rwf-knife.js,
   rwf-recommend-product.js). */




/* ============================== Contact Us ==============================
   Spec: .ai/plans/rw-forms-specs/spec-contact.md
   20 topic ids across 6 categories; the topic chip row is rebuilt per category
   (same dynamic-chip pattern as the Dropship preferred-method chips). */
(function () {
  'use strict';

  var TOPICS = {
    order: [['o_cancel', 'Cancel an order'], ['o_update', 'Change an order'], ['o_missing', 'Missing order or items'],
      ['o_damaged', 'Damaged items'], ['o_wrong', 'Wrong item received'], ['o_return', 'Return items'],
      ['o_question', 'Tracking, proof of delivery or invoice']],
    'new': [['n_talk', 'Talk to someone before ordering'], ['n_checkout', 'Problem at checkout']],
    product: [['p_question', 'Product question'], ['p_issue', 'Problem with a product'], ['p_stock', 'Check inventory'], ['p_sample', 'Request samples']],
    custom: [['c_quote', 'Customization quote'], ['c_issue', 'Problem with a custom order'], ['c_timeline', 'Production or shipping timeline'], ['c_other', 'Other custom question']],
    account: [['a_tax', 'Tax exemption request']],
    other: [['x_general', 'General question']]
  };
  var TOPIC_LABEL = {};
  Object.keys(TOPICS).forEach(function (c) { TOPICS[c].forEach(function (t) { TOPIC_LABEL[t[0]] = t[1]; }); });

  function start() {
    var RWF = window.RWF;
    var form = RWF.init('#rwf-contact', {
      id: 'contact',
      rules: {
        isOrder: function (v) { return (v.topic || '').indexOf('o_') === 0; },
        multiTopic: function (v) { return (TOPICS[v.cat] || []).length > 1; }
      },
      subject: function (v) { return TOPIC_LABEL[v.topic] || v.cat || ''; },
      init: function (f) {
        // Exempt-states options are the full US list by name (no CA list for
        // this field, per spec) — populated once since the list never changes.
        var box = f.$('[data-rwf-ms="taxStates"]');
        if (box) RWF.setMsOptions(box, RWF.data.US.map(function (s) { return { value: s[1], label: s[1] }; }));
      },
      vars: function (v) { return { topicName: TOPIC_LABEL[v.topic] || '' }; },
      onChange: function (name, v) {
        // Switching category clears the topic unless it's still valid for the
        // new category (so re-clicking the same category keeps it); a
        // single-topic category auto-picks its one topic.
        if (name !== 'cat') return;
        var topics = TOPICS[v.cat] || [];
        if (topics.length === 1) v.topic = topics[0][0];
        else if (!topics.some(function (t) { return t[0] === v.topic; })) v.topic = '';
      },
      render: function (v, f) {
        var box = f.$('[data-rwf-choice="topic"]');
        if (box) {
          var topics = TOPICS[v.cat] || [];
          var key = v.cat + ':' + topics.map(function (t) { return t[0]; }).join(',');
          if (box.getAttribute('data-built') !== key) {
            box.innerHTML = topics.map(function (t) {
              return '<button type="button" class="rwf-chip" data-value="' + t[0] + '" data-label="' + RWF.esc(t[1]) + '">' + RWF.esc(t[1]) + '</button>';
            }).join('');
            box.setAttribute('data-built', key);
          }
          RWF.paintChoice(box, v.topic);
        }
      },
      validate: {
        stockCases: function (val) { return /^\d+$/.test(val) ? '' : 'Cases needed (a number)'; }
      }
    });
    if (!form) return;
  }

  if (window.RWF && window.RWF.init) start();
  else document.addEventListener('DOMContentLoaded', start);
})();




/* ========================= Custom Product Request =========================
   Spec: .ai/plans/rw-forms-specs/spec-custom-product.md */
(function () {
  'use strict';

  function weeksAway(val) {
    if (!val) return null;
    var d = new Date(val + 'T00:00:00');
    if (isNaN(d.getTime())) return null;
    var today = new Date(); today.setHours(0, 0, 0, 0);
    return Math.floor((d - today) / (7 * 24 * 3600 * 1000));
  }

  function start() {
    var form = window.RWF.init('#rwf-custom-product', {
      id: 'custom-product',
      rules: {
        printing: function (v) { return !!v.printColors && v.printColors !== 'No printing'; }
      },
      subject: function (v) { return v.company || [v.first, v.last].filter(Boolean).join(' '); },
      validate: {
        refLink: function (val) { return String(val || '').indexOf('.') === -1 ? 'Link (check format)' : ''; },
        needBy: function (val) {
          if (!val) return '';
          var w = weeksAway(val);
          return w !== null && w < 0 ? 'Need by date (must be in the future)' : '';
        }
      },
      render: function (v, f) {
        var w = weeksAway(v.needBy);
        var soon = f.$('[data-needby-soon]');
        if (soon) soon.hidden = !(w !== null && w >= 0 && w < 2);
        var tight = f.$('[data-needby-tight]');
        if (tight) tight.hidden = !(w !== null && w >= 2 && w < 18);
      }
    });
    if (!form) return;
    if (window.RWF.wireAddressAutocomplete) {
      window.RWF.wireAddressAutocomplete(form);
      window.RWF.wireAddressAutocomplete(form, { prefix: 'quick' });
    }
  }

  if (window.RWF && window.RWF.init) start();
  else document.addEventListener('DOMContentLoaded', start);
})();




/* ============================ DiSC Assessment ============================
   Spec: .ai/plans/rw-forms-specs/spec-disc.md
   28 forced-choice word groups render from a data table (not hand-written
   markup) since the grid is 112 repeating word rows; only the group
   containers live in the Liquid section. Scores are computed for the
   internal email only — never shown to the candidate (see plan D4). */
(function () {
  'use strict';

  /* [word, mostKey, leastKey] per group; '' = that pick isn't scored. */
  var G = [
    [['Enthusiastic', 'I', 'I'], ['Daring', 'D', 'D'], ['Diplomatic', 'C', 'C'], ['Satisfied', 'S', 'S']],
    [['Cautious', 'C', 'C'], ['Determined', 'D', 'D'], ['Convincing', 'I', 'I'], ['Good-natured', 'S', '']],
    [['Friendly', 'I', ''], ['Accurate', 'C', 'C'], ['Outspoken', 'D', 'D'], ['Calm', '', 'S']],
    [['Talkative', 'I', 'I'], ['Controlled', 'C', 'C'], ['Conventional', 'S', 'S'], ['Decisive', 'D', 'D']],
    [['Adventurous', 'D', 'D'], ['Insightful', 'C', 'C'], ['Outgoing', 'I', 'I'], ['Moderate', 'S', 'S']],
    [['Gentle', 'S', 'S'], ['Persuasive', 'I', ''], ['Humble', '', 'C'], ['Original', '', 'D']],
    [['Expressive', 'I', 'I'], ['Conscientious', 'C', 'C'], ['Dominant', 'D', 'D'], ['Responsive', '', 'S']],
    [['Poised', 'I', 'I'], ['Observant', 'C', ''], ['Modest', 'S', 'S'], ['Impatient', 'D', 'D']],
    [['Tactful', 'C', 'C'], ['Agreeable', 'S', 'S'], ['Magnetic', 'I', 'I'], ['Insistent', 'D', 'D']],
    [['Brave', 'D', 'D'], ['Inspiring', 'I', 'I'], ['Submissive', 'S', 'S'], ['Timid', '', 'C']],
    [['Reserved', 'C', 'C'], ['Obliging', 'S', 'S'], ['Strong-willed', 'D', 'D'], ['Cheerful', 'I', 'I']],
    [['Stimulating', 'I', 'I'], ['Kind', 'S', 'S'], ['Perceptive', 'C', 'C'], ['Independent', 'D', 'D']],
    [['Competitive', 'D', 'D'], ['Considerate', 'S', 'S'], ['Joyful', 'I', 'I'], ['Private', 'C', 'C']],
    [['Fussy', 'C', 'C'], ['Obedient', 'S', 'S'], ['Firm', 'D', 'D'], ['Playful', 'I', 'I']],
    [['Attractive', 'I', 'I'], ['Introspective', 'C', ''], ['Stubborn', 'D', 'D'], ['Predictable', 'S', 'S']],
    [['Logical', 'C', 'C'], ['Bold', 'D', 'D'], ['Loyal', 'S', 'S'], ['Charming', 'I', 'I']],
    [['Sociable', 'I', 'I'], ['Patient', 'S', 'S'], ['Self-reliant', 'D', 'D'], ['Soft-spoken', 'C', 'C']],
    [['Willing', 'S', 'S'], ['Eager', 'D', ''], ['Thorough', 'C', 'C'], ['High-spirited', 'I', 'I']],
    [['Aggressive', 'D', 'D'], ['Extroverted', 'I', 'I'], ['Amiable', 'S', 'S'], ['Fearful', '', 'C']],
    [['Confident', 'I', 'I'], ['Sympathetic', 'S', 'S'], ['Impartial', '', 'C'], ['Assertive', 'D', 'D']],
    [['Well-disciplined', 'C', 'C'], ['Generous', 'S', 'S'], ['Animated', 'I', 'I'], ['Persistent', 'D', 'D']],
    [['Impulsive', 'I', 'I'], ['Introverted', 'C', 'C'], ['Forceful', 'D', 'D'], ['Easygoing', 'S', 'S']],
    [['Good mixer', 'I', 'I'], ['Refined', 'C', 'C'], ['Vigorous', 'D', 'D'], ['Lenient', 'S', 'S']],
    [['Captivating', 'I', 'I'], ['Contented', 'S', 'S'], ['Demanding', 'D', 'D'], ['Compliant', 'C', 'C']],
    [['Argumentative', 'D', 'D'], ['Systematic', 'C', 'C'], ['Cooperative', 'S', 'S'], ['Light-hearted', 'I', 'I']],
    [['Jovial', 'I', 'I'], ['Precise', 'C', 'C'], ['Direct', 'D', 'D'], ['Even-tempered', 'S', 'S']],
    [['Restless', 'D', 'D'], ['Neighborly', 'S', 'S'], ['Appealing', 'I', 'I'], ['Careful', 'C', 'C']],
    [['Respectful', 'C', 'C'], ['Pioneering', 'D', 'D'], ['Optimistic', 'I', 'I'], ['Helpful', 'S', 'S']]
  ];
  var STYLE = { D: 'Dominance', I: 'Influence', S: 'Steadiness', C: 'Conscientiousness' };
  var SEG = { D: [6, 0, -4, -7, -11, -14], I: [8, 6, 3, 1, -2, -5], S: [12, 9, 6, 3, 0, -4], C: [6, 3, 0, -2, -5, -8] };
  var PAGES = [[0, 7], [7, 14], [14, 21], [21, 28]]; // [start, end) group indices per step p1..p4

  function ans(v, gi) { return v.ans && v.ans[gi] || { m: '', l: '' }; }
  function setAns(v, gi, val) { v.ans = v.ans || {}; v.ans[gi] = val; }

  function segment(style, raw) {
    var t = SEG[style];
    for (var i = 0; i < t.length; i++) if (raw >= t[i]) return 7 - i;
    return 1;
  }

  function scoreAll(v) {
    var most = { D: 0, I: 0, S: 0, C: 0 }, least = { D: 0, I: 0, S: 0, C: 0 };
    G.forEach(function (words, gi) {
      var a = ans(v, gi);
      words.forEach(function (w) {
        if (a.m === w[0] && w[1]) most[w[1]]++;
        if (a.l === w[0] && w[2]) least[w[2]]++;
      });
    });
    var out = {}, maxSeg = 0;
    ['D', 'I', 'S', 'C'].forEach(function (k) {
      var raw = most[k] - least[k];
      var seg = segment(k, raw);
      out[k] = { raw: raw, seg: seg };
      if (seg > maxSeg) maxSeg = seg;
    });
    var primary = ['D', 'I', 'S', 'C'].filter(function (k) { return out[k].seg === maxSeg; })
      .map(function (k) { return k + ' (' + STYLE[k] + ')'; }).join(' + ');
    return { scores: out, primary: primary };
  }

  function answeredCount(v) {
    var n = 0;
    G.forEach(function (w, gi) { var a = ans(v, gi); if (a.m && a.l) n++; });
    return n;
  }

  function pageDone(v, page) {
    var r = PAGES[page], n = 0;
    for (var gi = r[0]; gi < r[1]; gi++) { var a = ans(v, gi); if (a.m && a.l) n++; }
    return n;
  }

  function groupHtml(gi) {
    var words = G[gi];
    var rows = words.map(function (w) {
      return '<div class="rwf-wr">' +
        '<span>' + w[0] + '</span>' +
        '<button type="button" class="rwf-pk rwf-pk--m" data-g="' + gi + '" data-role="m" data-word="' + w[0] + '" aria-label="' + w[0] + ': most like me">Most</button>' +
        '<button type="button" class="rwf-pk rwf-pk--l" data-g="' + gi + '" data-role="l" data-word="' + w[0] + '" aria-label="' + w[0] + ': least like me">Least</button>' +
        '</div>';
    }).join('');
    return '<div class="rwf-grp" data-grp="' + gi + '" role="group" aria-label="Question ' + (gi + 1) + '">' +
      '<div class="rwf-gh"><span>Question ' + (gi + 1) + '<span class="rwf-grp__done">Done</span></span><span class="rwf-wh">Most</span><span class="rwf-wh">Least</span></div>' +
      rows + '</div>';
  }

  function paintGroup(root, gi, v) {
    var card = root.querySelector('.rwf-grp[data-grp="' + gi + '"]');
    if (!card) return;
    var a = ans(v, gi);
    card.setAttribute('data-done', a.m && a.l ? 'true' : 'false');
    card.querySelectorAll('.rwf-pk').forEach(function (btn) {
      var role = btn.getAttribute('data-role'), word = btn.getAttribute('data-word');
      var pressed = role === 'm' ? a.m === word : a.l === word;
      var disabled = role === 'm' ? a.l === word : a.m === word;
      btn.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      btn.disabled = disabled && !pressed;
    });
  }

  function start() {
    var RWF = window.RWF;
    var root = document.querySelector('#rwf-disc');
    if (!root) return;
    // Build the 4 pages of group cards once; content never changes, only state.
    PAGES.forEach(function (r, page) {
      var box = root.querySelector('[data-groups-page="' + (page + 1) + '"]');
      if (!box) return;
      var html = '';
      for (var gi = r[0]; gi < r[1]; gi++) html += groupHtml(gi);
      box.innerHTML = html;
    });

    var form = RWF.init(root, {
      id: 'disc',
      subject: function (v) { return [v.first, v.last].filter(Boolean).join(' '); },
      display: {
        position: function (val, v) { return val === 'Other' ? (v.positionOther || 'Other') : val; }
      },
      stepErrors: function (stepId, v) {
        var pageIdx = { p1: 0, p2: 1, p3: 2, p4: 3 }[stepId];
        if (pageIdx == null) return [];
        var r = PAGES[pageIdx], errs = [];
        for (var gi = r[0]; gi < r[1]; gi++) {
          var a = ans(v, gi), n = gi + 1;
          if (!a.m && !a.l) errs.push('Question ' + n);
          else if (!a.m) errs.push('Question ' + n + ': most');
          else if (!a.l) errs.push('Question ' + n + ': least');
        }
        return errs;
      },
      extra: function (v) {
        var s = scoreAll(v);
        var rows = [{ label: 'Questions answered', value: answeredCount(v) + ' of 28' }, { label: 'Primary style', value: s.primary }];
        ['D', 'I', 'S', 'C'].forEach(function (k) {
          rows.push({ label: STYLE[k] + ' (' + k + ')', value: 'raw ' + (s.scores[k].raw > 0 ? '+' : '') + s.scores[k].raw + ', segment ' + s.scores[k].seg + ' of 7' });
        });
        return rows;
      },
      render: function (v, f) {
        for (var gi = 0; gi < 28; gi++) paintGroup(f.root, gi, v);
        PAGES.forEach(function (r, page) {
          var step = f.root.querySelector('.rwf-step[data-step="p' + (page + 1) + '"]');
          if (step) step.setAttribute('data-sub', 'Word choices (' + pageDone(v, page) + ' of 7 done)');
        });
      },
      vars: function (v) { return { answeredCount: answeredCount(v) + ' of 28' }; }
    });
    if (!form) return;

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.rwf-pk');
      if (!btn || btn.disabled) return;
      var gi = parseInt(btn.getAttribute('data-g'), 10);
      var role = btn.getAttribute('data-role');
      var word = btn.getAttribute('data-word');
      var a = Object.assign({}, ans(form.v, gi));
      a[role] = a[role] === word ? '' : word; // toggle off if re-clicking the same pick
      setAns(form.v, gi, a);
      form.touched['group' + gi] = true;
      form.save();
      form.refresh();
    });
  }

  if (window.RWF && window.RWF.init) start();
  else document.addEventListener('DOMContentLoaded', start);
})();




/* ============================ Distributor Application ============================
   Spec: .ai/plans/rw-forms-specs/spec-distributor.md */
(function () {
  'use strict';
  var NET = ['Net 15', 'Net 30'];

  function start() {
    var RWF = window.RWF;
    var form = RWF.init('#rwf-distributor', {
      id: 'distributor',
      rules: {
        isNet: function (v) { return NET.indexOf(v.terms) > -1; }
      },
      subject: function (v) { return v.legal || [v.first, v.last].filter(Boolean).join(' '); },
      vars: function (v) {
        var L = RWF.loc(v.country || 'US');
        return { countryName: v.country === 'other' ? (v.countryName || 'your country') : L.name };
      },
      display: {
        rep: function (val) { return val === 'none' ? 'None yet' : val; },
        terms: function (val) { return val === 'Prepay' ? 'Prepay (card or ACH)' : val; }
      },
      onChange: function (name, v) {
        // Rule 11: a country change clears the region picks tied to it. The
        // region <select> resets are handled generically; exStates is
        // distributor-only, so it is cleared here.
        if (name === 'country') delete v.exStates;
        // Rule 18: turning Prepay back on (or off Net) doesn't need to clear
        // refs data — hidden values are simply excluded from the payload.
      },
      render: function (v, f) {
        // Country-driven exempt-region multi-select: rebuild its option list
        // whenever the business country changes (US states / CA provinces;
        // 'other' uses the free-text field instead and needs no options).
        var box = f.$('[data-rwf-ms="exStates"]');
        var country = v.country || 'US';
        if (box && box.getAttribute('data-country') !== country) {
          var L = RWF.loc(country);
          RWF.setMsOptions(box, (L.list || []).map(function (s) { return { value: s[0], label: s[1] }; }));
          box.setAttribute('data-country', country);
          RWF.paintMulti(box, v.exStates || []);
        }
      }
    });
    if (!form) return;
    if (RWF.wireAddressAutocomplete) {
      RWF.wireAddressAutocomplete(form, { prefix: '', ownsCountry: true });
      RWF.wireAddressAutocomplete(form, { prefix: 'ship', countryField: 'country', ownsCountry: false });
    }
    form.root.addEventListener('click', function (e) {
      if (e.target.closest('[data-add-ref2]')) form.set('ref2', true);
      if (e.target.closest('[data-remove-ref2]')) {
        form.set('ref2', false);
        ['t2Co', 't2Contact', 't2Phone', 't2Email'].forEach(function (n) { form.set(n, ''); });
      }
    });
  }

  if (window.RWF && window.RWF.init) start();
  else document.addEventListener('DOMContentLoaded', start);
})();




/* ============================ E-Commerce & Dropship Partner Questionnaire ============================
   Spec: .ai/plans/rw-forms-specs/spec-dropship.md */
(function () {
  'use strict';
  var METHODS = ['EDI', 'Punchout', 'Email', 'Fax', 'Custom portal', 'Other'];

  function chosenMethods(v) {
    return METHODS.filter(function (m) { return (v.transmit || []).indexOf(m) > -1; });
  }

  function start() {
    var RWF = window.RWF;
    var form = RWF.init('#rwf-dropship', {
      id: 'dropship',
      rules: { hasTransmit: function (v) { return (v.transmit || []).length > 0; } },
      subject: function (v) { return v.company || [v.first, v.last].filter(Boolean).join(' '); },
      display: {
        pctEngage: function (val) { return val ? val + '%' : ''; },
        pctOrder: function (val) { return val ? val + '%' : ''; }
      },
      onChange: function (name, v) {
        // Preferred-method resolution: auto-pick when exactly one transmission
        // method is chosen; otherwise keep the pick only while it's still
        // among the selected methods (deselecting it clears the preference).
        if (name !== 'transmit') return;
        var chosen = chosenMethods(v);
        if (chosen.length === 1) v.pref = chosen[0];
        else if (chosen.indexOf(v.pref) === -1) v.pref = '';
      },
      render: function (v, f) {
        var chosen = chosenMethods(v);
        var box = f.$('[data-rwf-choice="pref"]');
        if (box) {
          var key = chosen.join('|');
          if (box.getAttribute('data-built') !== key) {
            box.innerHTML = chosen.map(function (m) {
              return '<button type="button" class="rwf-chip" data-value="' + RWF.esc(m) + '">' + RWF.esc(m) + '</button>';
            }).join('');
            box.setAttribute('data-built', key);
          }
          RWF.paintChoice(box, v.pref);
        }
        var step = f.root.querySelector('.rwf-step[data-step="integration"]');
        if (step) {
          var p = v.pref;
          var name = p === 'EDI' ? 'EDI setup' : p === 'Punchout' ? 'Punchout setup' : p ? 'Order setup' : 'Integration';
          step.setAttribute('data-title', name);
          step.setAttribute('data-sub', p ? 'For ' + p : 'Setup for your preferred method');
          step.setAttribute('data-intro', name === 'Order setup' ? 'Setup questions for submitting and confirming orders.' : p ? 'Setup questions for ' + p + ', your preferred method.' : 'Setup questions for your preferred ordering method.');
        }
      },
      validate: {
        website: function (val) { return String(val || '').indexOf('.') === -1 ? 'Company website (check format)' : ''; }
      }
    });
    if (!form) return;
  }

  if (window.RWF && window.RWF.init) start();
  else document.addEventListener('DOMContentLoaded', start);
})();




/* ============================== Personalized Knife ==============================
   Spec: .ai/plans/rw-forms-specs/spec-knife.md */
(function () {
  'use strict';
  var MAX = 20;
  var ALLOWED = /^[A-Za-z0-9 .,'&\-’]*$/;

  function engrMsg(val) {
    var s = String(val || '');
    if (!ALLOWED.test(s)) return 'Only letters, numbers, spaces and . , \' & - can be engraved.';
    if (s.trim().split(/\s+/).filter(Boolean).length > 3) return 'Keep it to 2–3 words so it fits the blade.';
    return '';
  }

  function ideas(v) {
    return [v.first ? 'Chef ' + v.first : '', 'Happy Holidays', v.last || '', v.company || '']
      .map(function (s) { return String(s).trim(); })
      .filter(function (s, i, a) { return s && s.length <= MAX && a.indexOf(s) === i; });
  }

  /* Renders the knife photo + engraving text (the live on-page preview,
     drawn with CSS) into a single PNG so the internal notification email
     carries a visual of what gets engraved — there's no file upload on this
     form otherwise. Resolves to [] (no attachment) if there's no engraving
     text yet, the photo hasn't loaded, or canvas export fails for any
     reason (e.g. a CORS-blocked image) — this is a best-effort extra, never
     something that should block the actual submission. */
  function buildEngravingImage(form) {
    return new Promise(function (resolve) {
      try {
        var txt = String((form.v && form.v.engraving) || '').trim();
        var imgEl = form.root.querySelector('.rwf-knife img');
        if (!txt || !imgEl) { resolve([]); return; }
        var draw = function () {
          try {
            var w = imgEl.naturalWidth || 1400;
            var h = imgEl.naturalHeight || 325;
            var canvas = document.createElement('canvas');
            canvas.width = w;
            canvas.height = h;
            var ctx = canvas.getContext('2d');
            ctx.drawImage(imgEl, 0, 0, w, h);
            ctx.font = 'italic ' + Math.round(w * 0.015) + 'px Georgia, "Times New Roman", serif';
            ctx.fillStyle = 'rgba(40,42,38,0.82)';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.fillText(txt, w * 0.34, h * 0.64);
            canvas.toBlob(function (blob) {
              resolve(blob ? [{ name: 'engraving-preview.png', file: new File([blob], 'engraving-preview.png', { type: 'image/png' }) }] : []);
            }, 'image/png');
          } catch (e) { resolve([]); }
        };
        if (imgEl.complete && imgEl.naturalWidth) draw();
        else {
          imgEl.addEventListener('load', draw, { once: true });
          imgEl.addEventListener('error', function () { resolve([]); }, { once: true });
        }
      } catch (e) { resolve([]); }
    });
  }

  function start() {
    var form = window.RWF.init('#rwf-knife', {
      id: 'knife',
      subject: function (v) { return [v.first, v.last].filter(Boolean).join(' ') + ' — “' + (v.engraving || '') + '”'; },
      extraFiles: buildEngravingImage,
      validate: {
        engraving: function (val) {
          var m = engrMsg(val);
          return m ? { pill: 'Engraving (see note)', inline: m } : '';
        }
      },
      display: {
        consult: function (val) { return val ? 'Yes, please contact me' : 'Not now'; }
      },
      render: function (v, f) {
        var txt = String(v.engraving || '');
        f.$$('[data-knife-overlay]').forEach(function (el) {
          el.textContent = txt.trim() ? txt : 'Your engraving';
          el.classList.toggle('is-filled', !!txt.trim());
        });
        var count = f.$('[data-engr-count]');
        if (count) count.textContent = txt.length + '/' + MAX;
        var box = f.$('[data-engr-ideas]');
        if (box) {
          box.innerHTML = ideas(v).map(function (s) {
            return '<button type="button" class="rwf-chip" data-idea="' + window.RWF.esc(s) + '" aria-pressed="' + (s === txt ? 'true' : 'false') + '">' + window.RWF.esc(s) + '</button>';
          }).join('');
        }
        // Engraving note shows live (before Continue), like the prototype.
        if (engrMsg(txt)) f.touched.engraving = true;
      }
    });
    if (!form) return;
    if (window.RWF.wireAddressAutocomplete) window.RWF.wireAddressAutocomplete(form);
    form.root.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-idea]');
      if (chip) form.set('engraving', chip.getAttribute('data-idea').slice(0, MAX));
    });
  }

  if (window.RWF && window.RWF.init) start();
  else document.addEventListener('DOMContentLoaded', start);
})();




/* ============================ Recommend a New Product ============================
   Same generic RW Forms notification path as every other rwf-* form (see
   assets/rwf-submit.js: viaEndpoint posts payload + files to the form's
   data-endpoint). It used to also create an Asana task via a separate,
   form-specific cfg.submit, but that's been removed — it's not needed. */
(function () {
  'use strict';

  function start() {
    var RWF = window.RWF;
    var form = RWF.init('#rwf-recommend-product', {
      id: 'recommend-product',
      rules: {},
      display: {
        meet: function (val, v) { return val === 'Yes' && v.bestTime ? val + ' — ' + v.bestTime : val; }
      },
      validate: {
        // Optional field, but the prototype still checks it when filled.
        refLink: function (val) { return String(val || '').indexOf('.') === -1 ? 'Link (check format)' : ''; }
      },
      successVars: function (v) {
        return { doneNext: v.meet === 'Yes' ? 'Since you’re open to meeting, we’ll reach out to set up a time.' : 'We’ll be in touch if we move forward with it.' };
      }
    });
    if (!form) return;
  }

  if (window.RWF && window.RWF.init) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
